import { render, staticRenderFns } from "./DiscountsHandler.vue?vue&type=template&id=407cea28&scoped=true&"
import script from "./DiscountsHandler.vue?vue&type=script&lang=js&"
export * from "./DiscountsHandler.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/styles-checkout-products.css?vue&type=style&index=0&id=407cea28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cea28",
  null
  
)

export default component.exports